import likely from 'ilyabirman-likely';
// var likely = require('ilyabirman-likely');

window.addEventListener('load', function() {
    // Finds all the widgets in the DOM and initializes them
    likely.initiate()
    console.log('All assets are loaded')
})



/*
window.onload

By default, it is fired when the entire page loads, including its content (images, CSS, scripts, etc.).
In some browsers it now takes over the role of document.onload and fires when the DOM is ready as well.

document.onload

It is called when the DOM is ready which can be prior to images and other external content is loaded.

var likely = require('ilyabirman-likely');

// Finds all the widgets in the DOM and initializes them
likely.initiate();


/*
https://github.com/NikolayRys/Likely

Setup
Link the files likely.css and likely.js from the compiled sources. Minified .min. versions also can be used for this.

If downloaded directly:

<!-- Head -->
<link href="path/to/likely.css" rel="stylesheet">
<!-- End of body -->
<script src="path/to/likely.js" type="text/javascript"></script>

<!-- Head -->
<link href="node_modules/ilyabirman-likely/release/likely.css"
      rel="stylesheet">
<!-- End of body -->
<script src="node_modules/ilyabirman-likely/release/likely.js"
        type="text/javascript"></script>

 */



